/* eslint-disable @typescript-eslint/no-explicit-any */
import { RemoteConfig, Value, getAll } from 'firebase/remote-config'
import { defaultConfig } from './defaultConfig'

export const getAllConfig = (remoteConfig: RemoteConfig): typeof defaultConfig => {
    const allConfig = getAll(remoteConfig)
    const allConfigKeys = Object.keys(allConfig)

    const ConvertRemoteConfigValues = <T extends Record<string, unknown>>(values: T, convertMethod: (value: Value) => any): T =>
        Object.keys(values).reduce((previousValue, key) => {
            if (allConfigKeys.includes(key)) {
                previousValue[key] = convertMethod(allConfig[key])
            }
            return previousValue
        }, {} as any)

    const booleans = ConvertRemoteConfigValues(defaultConfig.booleans, value => value.asBoolean())
    const strings = ConvertRemoteConfigValues(defaultConfig.strings, value => value.asString())
    const numbers = ConvertRemoteConfigValues(defaultConfig.numbers, value => value.asNumber())
    const jsons = ConvertRemoteConfigValues(defaultConfig.jsons, value => {
        const convertedValue: string = value?.asString() || '[]'
        return JSON.parse(convertedValue)
    })

    return {
        booleans,
        strings,
        numbers,
        jsons,
    }
}
